<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Vol01 from './Vol01.vue'
  import Vol02 from './Vol02.vue'
  import Vol03 from './Vol03.vue'
  import Vol04 from './Vol04.vue'
  import Vol05 from './Vol05.vue'
  import Vol06 from './Vol06.vue'
  import Jewel01 from './Jewel01.vue'
  import Jewel02 from './Jewel02.vue'
  import Jewel03 from './Jewel03.vue'
  import Jewel04 from './Jewel04.vue'
  import Jewel05 from './Jewel05.vue'
  import Jewel06 from './Jewel06.vue'
  import PriTama01 from './PriTama01.vue'
  import PriTama02 from './PriTama02.vue'
  import PriTama03 from './PriTama03.vue'
  import PriTama04 from './PriTama04.vue'
  import PriTama05 from './PriTama05.vue'
  import Promo2020 from './Promo2020.vue'


  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsVol01 = Vol01.data().items
  /** @type {ItemInfo[]} */ const itemsVol02 = Vol02.data().items
  /** @type {ItemInfo[]} */ const itemsVol03 = Vol03.data().items
  /** @type {ItemInfo[]} */ const itemsVol04 = Vol04.data().items
  /** @type {ItemInfo[]} */ const itemsVol05 = Vol05.data().items
  /** @type {ItemInfo[]} */ const itemsVol06 = Vol06.data().items
  /** @type {ItemInfo[]} */ const itemsJewel01 = Jewel01.data().items
  /** @type {ItemInfo[]} */ const itemsJewel02 = Jewel02.data().items
  /** @type {ItemInfo[]} */ const itemsJewel03 = Jewel03.data().items
  /** @type {ItemInfo[]} */ const itemsJewel04 = Jewel04.data().items
  /** @type {ItemInfo[]} */ const itemsJewel05 = Jewel05.data().items
  /** @type {ItemInfo[]} */ const itemsJewel06 = Jewel06.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama01 = PriTama01.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama02 = PriTama02.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama03 = PriTama03.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama04 = PriTama04.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama05 = PriTama05.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2020 = Promo2020.data().items


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-07-17',
        major: [
          'PT06',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] WR
          // ================================================================================


          // [NOTE] ER
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'ER6-01',
            rare        : 'ER',
            name        : 'クラシックミルキーレインボーだいあワンピ',
            imgUrl      : '/images/items/ER6-01.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'MR',
            type        : 'PO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'ER6-02',
            rare        : 'ER',
            name        : 'クラシックミルキーレインボーだいあシューズ',
            imgUrl      : '/images/items/ER6-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'ER6-03',
            rare        : 'ER',
            name        : 'クラシックミルキーレインボーだいあヘアアクセ',
            imgUrl      : '/images/items/ER6-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'ER',
          }),


          // [NOTE] JR
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'PKJ6-1',
            rare        : 'JR',
            name        : 'ブルーダイヤモンドジュエルドレス',
            imgUrl      : '/images/items/PKJ6-1.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 1900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PKJ6-2',
            rare        : 'JR',
            name        : 'ブルーダイヤモンドジュエルシューズ',
            imgUrl      : '/images/items/PKJ6-2.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PKJ6-3',
            rare        : 'JR',
            name        : 'ブルーダイヤモンドジュエルヘアアクセ',
            imgUrl      : '/images/items/PKJ6-3.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'JR',
          }),


          item({
            collection  : 'PT06',
            id          : 'PKJ6-4',
            rare        : 'JR',
            name        : 'ピンクダイヤモンドジュエルドレス',
            imgUrl      : '/images/items/PKJ6-4.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 1900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PKJ6-5',
            rare        : 'JR',
            name        : 'ピンクダイヤモンドジュエルシューズ',
            imgUrl      : '/images/items/PKJ6-5.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PKJ6-6',
            rare        : 'JR',
            name        : 'ピンクダイヤモンドジュエルヘアアクセ',
            imgUrl      : '/images/items/PKJ6-6.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'JR',
          }),


          item({
            collection  : 'PT06',
            id          : 'PKJ6-7',
            rare        : 'JR',
            name        : 'ときめきのレインボージュエルドレス',
            imgUrl      : '/images/items/PKJ6-7.png',
            kind        : 'ワンピース',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 1900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PKJ6-8',
            rare        : 'JR',
            name        : 'ときめきのレインボージュエルシューズ',
            imgUrl      : '/images/items/PKJ6-8.png',
            kind        : 'シューズ',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PKJ6-9',
            rare        : 'JR',
            name        : 'ときめきのレインボージュエルヘアアクセ',
            imgUrl      : '/images/items/PKJ6-9.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'JR',
          }),


          item({
            collection  : 'PT06',
            id          : 'PKJ6-10',
            rare        : 'JR',
            name        : 'ゆうじょうのピンクジュエルドレス',
            imgUrl      : '/images/items/PKJ6-10.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 1900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PKJ6-11',
            rare        : 'JR',
            name        : 'ゆうじょうのピンクジュエルシューズ',
            imgUrl      : '/images/items/PKJ6-11.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PKJ6-12',
            rare        : 'JR',
            name        : 'ゆうじょうのピンクジュエルヘアアクセ',
            imgUrl      : '/images/items/PKJ6-12.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'JR',
          }),


          // [NOTE] KR,JR キラチケいっぱい！ハッピーキャンペーン！クライマックス
          // ================================================================================

          externalItem(itemsVol06, 'PCH6-01', { collection: 'HappyCpnClimax' }),
          externalItem(itemsVol06, 'PCH6-02', { collection: 'HappyCpnClimax' }),
          externalItem(itemsVol06, 'PCH6-03', { collection: 'HappyCpnClimax' }),
          item({
            collection  : 'HappyCpnClimax',
            rare        : 'KR',
          }),

          externalItem(itemsJewel06, 'JR11-01', { collection: 'HappyCpnClimax' }),
          externalItem(itemsJewel06, 'JR11-02', { collection: 'HappyCpnClimax' }),
          externalItem(itemsJewel06, 'JR11-03', { collection: 'HappyCpnClimax' }),
          item({
            collection  : 'HappyCpnClimax',
            rare        : 'JR',
          }),


          // [NOTE] IR
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'IR06-01',
            rare        : 'IR',
            name        : 'キャッスルイルミナージュドレス',
            imgUrl      : '/images/items/IR06-01.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'LP',
            type        : 'PR',
            point       : 2000,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'IR06-02',
            rare        : 'IR',
            name        : 'キャッスルイルミナージュシューズ',
            imgUrl      : '/images/items/IR06-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'IR06-03',
            rare        : 'IR',
            name        : 'キャッスルイルミナージュヘアアクセ',
            imgUrl      : '/images/items/IR06-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT06',
            id          : 'IR06-04',
            rare        : 'IR',
            name        : 'パレードイルミナージュパープルドレス',
            imgUrl      : '/images/items/IR06-04.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 1600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'IR06-05',
            rare        : 'IR',
            name        : 'パレードイルミナージュパープルシューズ',
            imgUrl      : '/images/items/IR06-05.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'IR06-06',
            rare        : 'IR',
            name        : 'パレードイルミナージュパープルヘアアクセ',
            imgUrl      : '/images/items/IR06-06.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT06',
            id          : 'IR06-07',
            rare        : 'IR',
            name        : 'パレードイルミナージュブルードレス',
            imgUrl      : '/images/items/IR06-07.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'IR06-08',
            rare        : 'IR',
            name        : 'パレードイルミナージュブルーシューズ',
            imgUrl      : '/images/items/IR06-08.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'IR06-09',
            rare        : 'IR',
            name        : 'パレードイルミナージュブルーヘアアクセ',
            imgUrl      : '/images/items/IR06-09.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'IR',
          }),


          // [NOTE] IR (再録)
          // ================================================================================

          externalItem(itemsPriTama01, 'IR01-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama01, 'IR01-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),



          externalItem(itemsPriTama01, 'IR01-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-10', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-11', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-12', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-13', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-14', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-15', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-16', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-17', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-18', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          // [NOTE] FR
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'PT6-01',
            rare        : 'FR',
            name        : 'プリ☆ファンまほうつかいピュアワンピ',
            imgUrl      : '/images/items/PT6-01.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 2000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-02',
            rare        : 'FR',
            name        : 'プリ☆ファンまほうつかいピュアシューズ',
            imgUrl      : '/images/items/PT6-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-03',
            rare        : 'FR',
            name        : 'プリ☆ファンまほうつかいピュアヘアアクセ',
            imgUrl      : '/images/items/PT6-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'FR',
          }),


          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'PT6-04',
            rare        : 'HR',
            name        : 'あかずきんブラックトップス',
            imgUrl      : '/images/items/PT6-04.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 1100,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-05',
            rare        : 'HR',
            name        : 'あかずきんブラックスカート',
            imgUrl      : '/images/items/PT6-05.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 1050,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-06',
            rare        : 'HR',
            name        : 'あかずきんブラックシューズ',
            imgUrl      : '/images/items/PT6-06.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-07',
            rare        : 'HR',
            name        : 'あかずきんブラックヘアアクセ',
            imgUrl      : '/images/items/PT6-07.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-08',
            rare        : 'HR',
            name        : 'シンデレラパープルワンピ',
            imgUrl      : '/images/items/PT6-08.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 2000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-09',
            rare        : 'HR',
            name        : 'シンデレラパープルシューズ',
            imgUrl      : '/images/items/PT6-09.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-10',
            rare        : 'HR',
            name        : 'シンデレラパープルヘアアクセ',
            imgUrl      : '/images/items/PT6-10.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'PT6-11',
            rare        : 'PR',
            name        : 'パーフェクトムーントップス',
            imgUrl      : '/images/items/PT6-11.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'LP',
            type        : 'SE',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-12',
            rare        : 'PR',
            name        : 'パーフェクトムーンスカート',
            imgUrl      : '/images/items/PT6-12.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-13',
            rare        : 'PR',
            name        : 'パーフェクトムーンシューズ',
            imgUrl      : '/images/items/PT6-13.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'LP',
            type        : 'SE',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-14',
            rare        : 'PR',
            name        : 'パーフェクトムーンヘアアクセ',
            imgUrl      : '/images/items/PT6-14.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-15',
            rare        : 'PR',
            name        : 'パーフェクトシャイントップス',
            imgUrl      : '/images/items/PT6-15.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'LP',
            type        : 'NT',
            point       : 850,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-16',
            rare        : 'PR',
            name        : 'パーフェクトシャインパンツ',
            imgUrl      : '/images/items/PT6-16.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'NT',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-17',
            rare        : 'PR',
            name        : 'パーフェクトシャインシューズ',
            imgUrl      : '/images/items/PT6-17.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'LP',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-18',
            rare        : 'PR',
            name        : 'パーフェクトシャインヘアアクセ',
            imgUrl      : '/images/items/PT6-18.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'LP',
            type        : 'NT',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-19',
            rare        : 'PR',
            name        : 'ひかりのてんしトップス',
            imgUrl      : '/images/items/PT6-19.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-20',
            rare        : 'PR',
            name        : 'ひかりのてんしスカート',
            imgUrl      : '/images/items/PT6-20.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-21',
            rare        : 'PR',
            name        : 'ひかりのてんしシューズ',
            imgUrl      : '/images/items/PT6-21.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-22',
            rare        : 'PR',
            name        : 'ひかりのてんしヘアアクセ',
            imgUrl      : '/images/items/PT6-22.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'PT6-23',
            rare        : 'SR',
            name        : 'マジカる☆フレンドトップス',
            imgUrl      : '/images/items/PT6-23.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'PS',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-24',
            rare        : 'SR',
            name        : 'マジカる☆フレンドスカート',
            imgUrl      : '/images/items/PT6-24.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'PS',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-25',
            rare        : 'SR',
            name        : 'マジカる☆フレンドシューズ',
            imgUrl      : '/images/items/PT6-25.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-26',
            rare        : 'SR',
            name        : 'マジカる☆フレンドヘアアクセ',
            imgUrl      : '/images/items/PT6-26.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'PS',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-27',
            rare        : 'SR',
            name        : 'ハピエストウエディングブラックトップス',
            imgUrl      : '/images/items/PT6-27.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-28',
            rare        : 'SR',
            name        : 'ハピエストウエディングブラックスカート',
            imgUrl      : '/images/items/PT6-28.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-29',
            rare        : 'SR',
            name        : 'ハピエストウエディングブラックシューズ',
            imgUrl      : '/images/items/PT6-29.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-30',
            rare        : 'SR',
            name        : 'ハピエストウエディングブラックヘアアクセ',
            imgUrl      : '/images/items/PT6-30.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-31',
            rare        : 'SR',
            name        : 'ピュアネスウエディングブラックトップス',
            imgUrl      : '/images/items/PT6-31.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-32',
            rare        : 'SR',
            name        : 'ピュアネスウエディングブラックパンツ',
            imgUrl      : '/images/items/PT6-32.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-33',
            rare        : 'SR',
            name        : 'ピュアネスウエディングブラックシューズ',
            imgUrl      : '/images/items/PT6-33.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-34',
            rare        : 'SR',
            name        : 'ピュアネスウエディングブラックヘアアクセ',
            imgUrl      : '/images/items/PT6-34.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-35',
            rare        : 'SR',
            name        : 'ミルキーウェイたんぽぽワンピ',
            imgUrl      : '/images/items/PT6-35.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-36',
            rare        : 'SR',
            name        : 'ミルキーウェイたんぽぽシューズ',
            imgUrl      : '/images/items/PT6-36.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-37',
            rare        : 'SR',
            name        : 'ミルキーウェイたんぽぽヘアアクセ',
            imgUrl      : '/images/items/PT6-37.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'SR',
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-38',
            rare        : 'SR',
            name        : 'きもだめしグリーントップス',
            imgUrl      : '/images/items/PT6-38.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-39',
            rare        : 'SR',
            name        : 'きもだめしグリーンパンツ',
            imgUrl      : '/images/items/PT6-39.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-40',
            rare        : 'SR',
            name        : 'きもだめしグリーンシューズ',
            imgUrl      : '/images/items/PT6-40.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-41',
            rare        : 'SR',
            name        : 'きもだめしグリーンヘアアクセ',
            imgUrl      : '/images/items/PT6-41.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-42',
            rare        : 'SR',
            name        : 'チェッカーポリスレッドトップス',
            imgUrl      : '/images/items/PT6-42.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-43',
            rare        : 'SR',
            name        : 'チェッカーポリスレッドスカート',
            imgUrl      : '/images/items/PT6-43.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-44',
            rare        : 'SR',
            name        : 'チェッカーポリスレッドシューズ',
            imgUrl      : '/images/items/PT6-44.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-45',
            rare        : 'SR',
            name        : 'チェッカーポリスレッドヘアアクセ',
            imgUrl      : '/images/items/PT6-45.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'Molly',
            id          : 'MF-71',
            rare        : 'SR',
            name        : 'パーフェクトムーンノーブルトップス',
            imgUrl      : '/images/items/MF-71.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-72',
            rare        : 'SR',
            name        : 'パーフェクトムーンノーブルスカート',
            imgUrl      : '/images/items/MF-72.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'LP',
            type        : 'SE',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-73',
            rare        : 'SR',
            name        : 'パーフェクトムーンノーブルシューズ',
            imgUrl      : '/images/items/MF-73.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'LP',
            type        : 'SE',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-74',
            rare        : 'SR',
            name        : 'パーフェクトムーンノーブルヘアアクセ',
            imgUrl      : '/images/items/MF-74.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'LP',
            type        : 'SE',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'PT6-46',
            rare        : 'R',
            name        : 'フライングスカイフラミンゴトップス',
            imgUrl      : '/images/items/PT6-46.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-47',
            rare        : 'R',
            name        : 'フライングスカイフラミンゴパンツ',
            imgUrl      : '/images/items/PT6-47.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-48',
            rare        : 'R',
            name        : 'フライングスカイフラミンゴシューズ',
            imgUrl      : '/images/items/PT6-48.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-49',
            rare        : 'R',
            name        : 'フライングスカイフラミンゴヘアアクセ',
            imgUrl      : '/images/items/PT6-49.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-50',
            rare        : 'R',
            name        : 'スイートレトロブラウンワンピ',
            imgUrl      : '/images/items/PT6-50.png',
            kind        : 'ワンピース',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-51',
            rare        : 'R',
            name        : 'スイートレトロブラウンシューズ',
            imgUrl      : '/images/items/PT6-51.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-52',
            rare        : 'R',
            name        : 'スイートレトロブラウンヘアアクセ',
            imgUrl      : '/images/items/PT6-52.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'R',
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-53',
            rare        : 'R',
            name        : 'スイートレトロブルーワンピ',
            imgUrl      : '/images/items/PT6-53.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-54',
            rare        : 'R',
            name        : 'スイートレトロブルーシューズ',
            imgUrl      : '/images/items/PT6-54.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-55',
            rare        : 'R',
            name        : 'スイートレトロブルーヘアアクセ',
            imgUrl      : '/images/items/PT6-55.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            rare        : 'R',
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-56',
            rare        : 'R',
            name        : 'フェアリーイエロートップス',
            imgUrl      : '/images/items/PT6-56.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-57',
            rare        : 'R',
            name        : 'フェアリーイエロースカート',
            imgUrl      : '/images/items/PT6-57.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-58',
            rare        : 'R',
            name        : 'フェアリーイエローシューズ',
            imgUrl      : '/images/items/PT6-58.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-59',
            rare        : 'R',
            name        : 'フェアリーイエローヘアアクセ',
            imgUrl      : '/images/items/PT6-59.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-60',
            rare        : 'R',
            name        : 'フェアリーピンクトップス',
            imgUrl      : '/images/items/PT6-60.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-61',
            rare        : 'R',
            name        : 'フェアリーピンクスカート',
            imgUrl      : '/images/items/PT6-61.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-62',
            rare        : 'R',
            name        : 'フェアリーピンクシューズ',
            imgUrl      : '/images/items/PT6-62.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-63',
            rare        : 'R',
            name        : 'フェアリーピンクヘアアクセ',
            imgUrl      : '/images/items/PT6-63.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'PT06',
            id          : 'PT6-64',
            rare        : 'N',
            name        : 'ガーデンフラワーピンクトップス',
            imgUrl      : '/images/items/PT6-64.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-65',
            rare        : 'N',
            name        : 'ガーデンフラワーピンクスカート',
            imgUrl      : '/images/items/PT6-65.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 400,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-66',
            rare        : 'N',
            name        : 'ガーデンフラワーピンクシューズ',
            imgUrl      : '/images/items/PT6-66.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-67',
            rare        : 'N',
            name        : 'ガーデンフラワーピンクヘアアクセ',
            imgUrl      : '/images/items/PT6-67.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-68',
            rare        : 'N',
            name        : 'ロッキンサマーブルートップス',
            imgUrl      : '/images/items/PT6-68.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-69',
            rare        : 'N',
            name        : 'ロッキンサマーブルースカート',
            imgUrl      : '/images/items/PT6-69.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-70',
            rare        : 'N',
            name        : 'ロッキンサマーブルーシューズ',
            imgUrl      : '/images/items/PT6-70.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-71',
            rare        : 'N',
            name        : 'ロッキンサマーブルーヘアアクセ',
            imgUrl      : '/images/items/PT6-71.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT06',
            id          : 'PT6-72',
            rare        : 'N',
            name        : 'にじのマーチピンクトップス',
            imgUrl      : '/images/items/PT6-72.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-73',
            rare        : 'N',
            name        : 'にじのマーチピンクスカート',
            imgUrl      : '/images/items/PT6-73.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-74',
            rare        : 'N',
            name        : 'にじのマーチピンクシューズ',
            imgUrl      : '/images/items/PT6-74.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT06',
            id          : 'PT6-75',
            rare        : 'N',
            name        : 'にじのマーチピンクヘアアクセ',
            imgUrl      : '/images/items/PT6-75.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================



          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'PBox',
            id          : 'PB-157',
            rare        : 'SR',
            name        : 'いはんチケット',
            imgUrl      : '/images/items/PB-157.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          externalItem(itemsVol02, 'PCH2-77', { collection: 'PBox' }),
          externalItem(itemsVol02, 'PCH2-78', { collection: 'PBox' }),
          externalItem(itemsVol03, 'PCH3-87', { collection: 'PBox' }),


          item({
            collection  : 'PBox',
            id          : 'PB-124',
            rare        : 'PR',
            name        : 'ゴールドキラッCHU',
            imgUrl      : '/images/items/PB-124.png',
            kind        : 'パシャッとアイテム',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-125',
            rare        : 'SR',
            name        : 'キラッCHU',
            imgUrl      : '/images/items/PB-125.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-126',
            rare        : 'SR',
            name        : 'おおきなキラッCHU',
            imgUrl      : '/images/items/PB-126.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-127',
            rare        : 'SR',
            name        : 'メルパン',
            imgUrl      : '/images/items/PB-127.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'LP',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PBox',
            id          : 'PB-128',
            rare        : 'SR',
            name        : 'ラビリィ',
            imgUrl      : '/images/items/PB-128.png',
            kind        : 'パシャッとアイテム',
            color       : '緑',
            brand       : 'LP',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-129',
            rare        : 'SR',
            name        : 'ソルル',
            imgUrl      : '/images/items/PB-129.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'LP',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-130',
            rare        : 'SR',
            name        : 'ルルナ',
            imgUrl      : '/images/items/PB-130.png',
            kind        : 'パシャッとアイテム',
            color       : '黒',
            brand       : 'LP',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PB-131',
            rare        : 'PR',
            name        : 'クイーンズロッド',
            imgUrl      : '/images/items/PB-131.png',
            kind        : 'パシャッとアイテム',
            color       : '金',
            brand       : 'LP',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリ☆チャンサンキューキャンペーン！
          // ================================================================================

          item({
            collection  : '999Campaign',
            id          : 'IR06-10',
            rare        : 'IR',
            name        : 'イルミナインファンタジードレス',
            imgUrl      : '/images/items/IR06-10.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 1900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR06-11',
            rare        : 'IR',
            name        : 'イルミナインファンタジーシューズ',
            imgUrl      : '/images/items/IR06-11.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR06-12',
            rare        : 'IR',
            name        : 'イルミナインファンタジーヘアアクセ',
            imgUrl      : '/images/items/IR06-12.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({ collection: '999Campaign', rare: 'IR' }),


          item({
            collection  : '999Campaign',
            id          : 'IR06-13',
            rare        : 'IR',
            name        : 'イルミナインパレードドレス',
            imgUrl      : '/images/items/IR06-13.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 1900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR06-14',
            rare        : 'IR',
            name        : 'イルミナインパレードシューズ',
            imgUrl      : '/images/items/IR06-14.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR06-15',
            rare        : 'IR',
            name        : 'イルミナインパレードヘアアクセ',
            imgUrl      : '/images/items/IR06-15.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({ collection: '999Campaign', rare: 'IR' }),


          item({
            collection  : '999Campaign',
            id          : 'IR06-16',
            rare        : 'IR',
            name        : 'イルミナインマジックドレス',
            imgUrl      : '/images/items/IR06-16.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'MM',
            type        : 'SE',
            point       : 1900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR06-17',
            rare        : 'IR',
            name        : 'イルミナインマジックシューズ',
            imgUrl      : '/images/items/IR06-17.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MM',
            type        : 'SE',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR06-18',
            rare        : 'IR',
            name        : 'イルミナインマジックヘアアクセ',
            imgUrl      : '/images/items/IR06-18.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'MM',
            type        : 'SE',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({ collection: '999Campaign', rare: 'IR' }),


          item({
            collection  : '999Campaign',
            id          : 'PB-139',
            rare        : 'SR',
            name        : 'アロマットカードあろまトップス',
            imgUrl      : '/images/items/PB-139.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-140',
            rare        : 'SR',
            name        : 'アロマットカードあろまスカート',
            imgUrl      : '/images/items/PB-140.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-141',
            rare        : 'SR',
            name        : 'アロマットカードあろまシューズ',
            imgUrl      : '/images/items/PB-141.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-142',
            rare        : 'SR',
            name        : 'アロマットカードあろまヘアアクセ',
            imgUrl      : '/images/items/PB-142.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-136',
            rare        : 'SR',
            name        : 'パパラジュククールカラーワンピ',
            imgUrl      : '/images/items/PB-136.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-137',
            rare        : 'SR',
            name        : 'パパラジュククールカラーシューズ',
            imgUrl      : '/images/items/PB-137.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-138',
            rare        : 'SR',
            name        : 'パパラジュククールカラーヘアアクセ',
            imgUrl      : '/images/items/PB-138.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({ collection: '999Campaign', rare: 'SR' }),


          item({
            collection  : '999Campaign',
            id          : 'PB-143',
            rare        : 'SR',
            name        : 'アメカジスカイスカジャン',
            imgUrl      : '/images/items/PB-143.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-144',
            rare        : 'SR',
            name        : 'アメカジスカイスカート',
            imgUrl      : '/images/items/PB-144.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-145',
            rare        : 'SR',
            name        : 'アメカジスカイシューズ',
            imgUrl      : '/images/items/PB-145.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-146',
            rare        : 'SR',
            name        : 'アメカジスカイヘアアクセ',
            imgUrl      : '/images/items/PB-146.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-147',
            rare        : 'SR',
            name        : 'ノルディックレッドボアワンピ',
            imgUrl      : '/images/items/PB-147.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-148',
            rare        : 'SR',
            name        : 'ノルディックレッドボアシューズ',
            imgUrl      : '/images/items/PB-148.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-149',
            rare        : 'SR',
            name        : 'ノルディックレッドボアヘアアクセ',
            imgUrl      : '/images/items/PB-149.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({ collection: '999Campaign', rare: 'SR' }),


          item({
            collection  : '999Campaign',
            id          : 'PB-150',
            rare        : 'SR',
            name        : 'ゆうびんやさんおひさまワンピ',
            imgUrl      : '/images/items/PB-150.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-151',
            rare        : 'SR',
            name        : 'ゆうびんやさんおひさまシューズ',
            imgUrl      : '/images/items/PB-151.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-152',
            rare        : 'SR',
            name        : 'ゆうびんやさんおひさまヘアアクセ',
            imgUrl      : '/images/items/PB-152.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({ collection: '999Campaign', rare: 'SR' }),


          item({
            collection  : '999Campaign',
            id          : 'PB-132',
            rare        : 'SR',
            name        : 'ガーリッシュイエロースカジャン',
            imgUrl      : '/images/items/PB-132.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-133',
            rare        : 'SR',
            name        : 'ガーリッシュイエロースカート',
            imgUrl      : '/images/items/PB-133.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-134',
            rare        : 'SR',
            name        : 'ガーリッシュイエローシューズ',
            imgUrl      : '/images/items/PB-134.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-135',
            rare        : 'SR',
            name        : 'ガーリッシュイエローヘアアクセ',
            imgUrl      : '/images/items/PB-135.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-153',
            rare        : 'SR',
            name        : 'フェアリープリンセストップス',
            imgUrl      : '/images/items/PB-153.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-154',
            rare        : 'SR',
            name        : 'フェアリープリンセススカート',
            imgUrl      : '/images/items/PB-154.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-155',
            rare        : 'SR',
            name        : 'フェアリープリンセスシューズ',
            imgUrl      : '/images/items/PB-155.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-156',
            rare        : 'SR',
            name        : 'フェアリープリンセスヘアアクセ',
            imgUrl      : '/images/items/PB-156.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] キラッとアイドルチャンネル KR
          // ================================================================================

          externalItem(itemsVol01, 'PCH1-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol02, 'PCH2-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol02, 'PCH2-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-06', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol03, 'PCH3-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol03, 'PCH3-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-06', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol04, 'PCH4-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol05, 'PCH5-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          // [NOTE] キラッとアイドルチャンネル PR
          // ================================================================================

          externalItem(itemsVol01, 'PCH1-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-06', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-07', { collection: 'KirattoIdol' }),


          externalItem(itemsVol01, 'PCH1-12', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-13', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-14', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-15', { collection: 'KirattoIdol' }),


          externalItem(itemsVol02, 'PCH2-07', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-08', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-10', { collection: 'KirattoIdol' }),


          externalItem(itemsVol02, 'PCH2-12', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-13', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-14', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-15', { collection: 'KirattoIdol' }),


          externalItem(itemsVol03, 'PCH3-07', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-08', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-10', { collection: 'KirattoIdol' }),


          externalItem(itemsVol04, 'PCH4-65', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-66', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-67', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-68', { collection: 'KirattoIdol' }),


          externalItem(itemsVol05, 'PCH5-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-06', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-07', { collection: 'KirattoIdol' }),


          // [NOTE] キラッとアイドルチャンネル SR
          // ================================================================================

          externalItem(itemsVol04, 'SP-009', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'SP-010', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'SP-011', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'SP-012', { collection: 'KirattoIdol' }),


          externalItem(itemsVol05, 'PCH5-16', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-17', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-18', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-19', { collection: 'KirattoIdol' }),


          externalItem(itemsVol05, 'PCH5-78', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-79', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-80', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-81', { collection: 'KirattoIdol' }),

          externalItem(itemsVol05, 'PCH5-20', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-86', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'SR' }),
          item({ collection: 'KirattoIdol', rare: 'SR' }),


          // [NOTE] キラッとアイドルチャンネル R
          // ================================================================================

          externalItem(itemsVol01, 'PCH1-38', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-39', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),


          externalItem(itemsVol01, 'PCH1-40', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-41', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-42', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),

          externalItem(itemsVol02, 'PCH2-43', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-44', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),


          externalItem(itemsVol02, 'PCH2-45', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-46', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-47', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),


          externalItem(itemsVol04, 'PCH4-32', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-33', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-34', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-35', { collection: 'KirattoIdol' }),


          externalItem(itemsVol06, 'PCH6-25', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-26', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-27', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-28', { collection: 'KirattoIdol' }),

          externalItem(itemsVol01, 'PCH1-69', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-64', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),



          // [NOTE] キラッとアイドルチャンネル N
          // ================================================================================

          externalItem(itemsVol02, 'PCH2-65', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-66', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-67', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'N' }),


          externalItem(itemsVol03, 'PCH3-66', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-67', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),
          item({ collection: 'KirattoIdol', rare: 'R' }),


          externalItem(itemsVol04, 'PCH4-40', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-41', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-42', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-43', { collection: 'KirattoIdol' }),


          // [NOTE] ジュエルアイドルチャンネル JR
          // ================================================================================

          externalItem(itemsJewel01, 'JR1-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'JR1-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'JR1-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel02, 'JR2-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel02, 'JR2-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel02, 'JR2-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel02, 'JR3-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel02, 'JR3-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel02, 'JR3-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel03, 'JR4-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'JR4-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'JR4-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel03, 'JR5-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'JR5-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'JR5-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel04, 'JR6-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'JR6-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'JR6-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel04, 'JR7-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'JR7-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'JR7-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel05, 'JR8-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'JR8-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'JR8-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel05, 'JR9-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'JR9-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'JR9-03', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'JR' }),


          externalItem(itemsJewel06, 'JR10-01', { collection: 'JewelIdol' }),
          externalItem(itemsJewel06, 'JR10-02', { collection: 'JewelIdol' }),
          externalItem(itemsJewel06, 'JR10-03', { collection: 'JewelIdol' }),


          // [NOTE] ジュエルアイドルチャンネル PR
          // ================================================================================

          externalItem(itemsJewel01, 'J1-04', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'J1-05', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'J1-06', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'J1-07', { collection: 'JewelIdol' }),


          externalItem(itemsJewel01, 'J1-08', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'J1-09', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'J1-10', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'PR' }),


          externalItem(itemsJewel02, 'J2-64', { collection: 'JewelIdol' }),
          externalItem(itemsJewel02, 'J2-65', { collection: 'JewelIdol' }),
          externalItem(itemsJewel02, 'J2-66', { collection: 'JewelIdol' }),
          externalItem(itemsJewel02, 'J2-67', { collection: 'JewelIdol' }),


          externalItem(itemsJewel03, 'J3-07', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-08', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-09', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'PR' }),


          externalItem(itemsJewel03, 'J3-79', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-80', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-81', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-82', { collection: 'JewelIdol' }),


          externalItem(itemsJewel03, 'J3-83', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-84', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-85', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-86', { collection: 'JewelIdol' }),


          externalItem(itemsJewel03, 'J3-90', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-91', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-92', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-93', { collection: 'JewelIdol' }),


          externalItem(itemsJewel04, 'J4-13', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-14', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-15', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-16', { collection: 'JewelIdol' }),


          externalItem(itemsJewel04, 'J4-17', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-18', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-19', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-20', { collection: 'JewelIdol' }),


          externalItem(itemsJewel04, 'J4-94', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-95', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-96', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-97', { collection: 'JewelIdol' }),


          externalItem(itemsJewel05, 'J5-15', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'J5-16', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'J5-17', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'J5-18', { collection: 'JewelIdol' }),


          externalItem(itemsJewel05, 'J5-23', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'J5-24', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'J5-25', { collection: 'JewelIdol' }),
          externalItem(itemsJewel05, 'J5-26', { collection: 'JewelIdol' }),


          externalItem(itemsJewel06, 'J6-19', { collection: 'JewelIdol' }),
          externalItem(itemsJewel06, 'J6-20', { collection: 'JewelIdol' }),
          externalItem(itemsJewel06, 'J6-21', { collection: 'JewelIdol' }),
          externalItem(itemsJewel06, 'J6-22', { collection: 'JewelIdol' }),


          // [NOTE] ジュエルアイドルチャンネル SR
          // ================================================================================

          externalItem(itemsJewel03, 'J3-94', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-95', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-96', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-97', { collection: 'JewelIdol' }),


          externalItem(itemsJewel06, 'J6-23', { collection: 'JewelIdol' }),
          externalItem(itemsJewel06, 'J6-24', { collection: 'JewelIdol' }),
          externalItem(itemsJewel06, 'J6-25', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'SR' }),


          externalItem(itemsJewel02, 'J2-83', { collection: 'JewelIdol' }),
          externalItem(itemsJewel06, 'J6-42', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'SR' }),
          item({ collection: 'JewelIdol', rare: 'SR' }),


          // [NOTE] ジュエルアイドルチャンネル R
          // ================================================================================

          externalItem(itemsJewel01, 'J1-84', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'J1-85', { collection: 'JewelIdol' }),
          externalItem(itemsJewel01, 'J1-86', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'R' }),


          externalItem(itemsJewel03, 'J3-31', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-32', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-33', { collection: 'JewelIdol' }),
          item({ collection: 'JewelIdol', rare: 'R' }),


          externalItem(itemsJewel01, 'J1-30', { collection: 'JewelIdol' }),
          externalItem(itemsJewel02, 'J2-38', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-52', { collection: 'JewelIdol' }),
          externalItem(itemsJewel04, 'J4-118', { collection: 'JewelIdol' }),



          // [NOTE] ジュエルアイドルチャンネル N
          // ================================================================================

          externalItem(itemsJewel03, 'J3-58', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-59', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-60', { collection: 'JewelIdol' }),
          externalItem(itemsJewel03, 'J3-61', { collection: 'JewelIdol' }),


          // [NOTE] ふっこくマスコット認定試験
          // ================================================================================

          externalItem(itemsPromo2020, 'IR04-19', { collection: 'MascotExam' }),
          externalItem(itemsPromo2020, 'IR02-10', { collection: 'MascotExam' }),
          externalItem(itemsPromo2020, 'IR03-10', { collection: 'MascotExam' }),
          item({ collection: 'MascotExam', rare: 'IR' }),


          // [NOTE] プリ☆チャンファンタジーふっこくチャンネル2
          // ================================================================================

          externalItem(itemsPriTama02, 'PT2-05', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama02, 'PT2-06', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama02, 'PT2-07', { collection: 'ReappearFR' }),
          item({ collection: 'ReappearFR',  rare: 'FR' }),


          externalItem(itemsPriTama04, 'PT4-01', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama04, 'PT4-02', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama04, 'PT4-03', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama04, 'PT4-04', { collection: 'ReappearFR' }),


          externalItem(itemsPriTama04, 'PT4-05', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama04, 'PT4-06', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama04, 'PT4-07', { collection: 'ReappearFR' }),
          item({ collection: 'ReappearFR',  rare: 'FR' }),


          externalItem(itemsPriTama05, 'PT5-01', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama05, 'PT5-02', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama05, 'PT5-03', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama05, 'PT5-04', { collection: 'ReappearFR' }),


          externalItem(itemsPriTama05, 'PT5-05', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama05, 'PT5-06', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama05, 'PT5-07', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama05, 'PT5-08', { collection: 'ReappearFR' }),


          externalItem(itemsPriTama01, 'PT1-01', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-02', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-03', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-04', { collection: 'ReappearFR' }),


          externalItem(itemsPriTama01, 'PT1-05', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-06', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-07', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-08', { collection: 'ReappearFR' }),

          externalItem(itemsPriTama02, 'PT2-01', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama02, 'PT2-02', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama02, 'PT2-03', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama02, 'PT2-04', { collection: 'ReappearFR' }),


          externalItem(itemsPriTama03, 'PT3-01', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-02', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-03', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-04', { collection: 'ReappearFR' }),


          externalItem(itemsPriTama03, 'PT3-05', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-06', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-07', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-08', { collection: 'ReappearFR' }),


          // [NOTE] ふっこく！ラブパトリーナチャンネル
          // ================================================================================

          externalItem(itemsPriTama02, 'PT2-108', { collection: 'LovePato' }),
          externalItem(itemsPriTama02, 'PT2-109', { collection: 'LovePato' }),
          externalItem(itemsPriTama02, 'PT2-110', { collection: 'LovePato' }),
          item({ collection: 'LovePato',  rare: 'SR' }),


          externalItem(itemsPriTama04, 'PT4-106', { collection: 'LovePato' }),
          externalItem(itemsPriTama04, 'PT4-107', { collection: 'LovePato' }),
          externalItem(itemsPriTama04, 'PT4-108', { collection: 'LovePato' }),
          item({ collection: 'LovePato',  rare: 'SR' }),


          externalItem(itemsPriTama05, 'PT5-108', { collection: 'LovePato' }),
          externalItem(itemsPriTama05, 'PT5-109', { collection: 'LovePato' }),
          externalItem(itemsPriTama05, 'PT5-110', { collection: 'LovePato' }),
          item({ collection: 'LovePato',  rare: 'SR' }),


          externalItem(itemsPriTama05, 'PT5-111', { collection: 'LovePato' }),
          externalItem(itemsPriTama05, 'PT5-112', { collection: 'LovePato' }),
          externalItem(itemsPriTama05, 'PT5-113', { collection: 'LovePato' }),
          item({ collection: 'LovePato',  rare: 'SR' }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          externalItem(itemsJewel04, 'NC-J3-01', { collection: 'Nico' }),
          externalItem(itemsJewel04, 'NC-J3-02', { collection: 'Nico' }),
          externalItem(itemsJewel04, 'NC-J3-03', { collection: 'Nico' }),
          item({ collection: 'Nico',  rare: 'PR' }),


          externalItem(itemsJewel05, 'NC-J5-01', { collection: 'Nico' }),
          externalItem(itemsJewel05, 'NC-J5-02', { collection: 'Nico' }),
          externalItem(itemsJewel05, 'NC-J5-03', { collection: 'Nico' }),
          item({ collection: 'Nico',  rare: 'PR' }),


          externalItem(itemsJewel05, 'NC-J5-59', { collection: 'Nico' }),
          externalItem(itemsJewel05, 'NC-J5-60', { collection: 'Nico' }),
          externalItem(itemsJewel05, 'NC-J5-61', { collection: 'Nico' }),
          item({ collection: 'Nico',  rare: 'PR' }),


          externalItem(itemsJewel06, 'NC-J6-01', { collection: 'Nico' }),
          externalItem(itemsJewel06, 'NC-J6-02', { collection: 'Nico' }),
          externalItem(itemsJewel06, 'NC-J6-03', { collection: 'Nico' }),
          item({ collection: 'Nico',  rare: 'PR' }),


          externalItem(itemsPriTama01, 'NC-PT1-01', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-02', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-03', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-04', { collection: 'Nico' }),


          externalItem(itemsPriTama01, 'NC-PT1-05', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-06', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-07', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-08', { collection: 'Nico' }),


          externalItem(itemsPriTama02, 'NC-PT2-01', { collection: 'Nico' }),
          externalItem(itemsPriTama02, 'NC-PT2-02', { collection: 'Nico' }),
          externalItem(itemsPriTama02, 'NC-PT2-03', { collection: 'Nico' }),
          externalItem(itemsPriTama02, 'NC-PT2-04', { collection: 'Nico' }),


          externalItem(itemsPriTama02, 'NC-PT2-05', { collection: 'Nico' }),
          externalItem(itemsPriTama02, 'NC-PT2-06', { collection: 'Nico' }),
          externalItem(itemsPriTama02, 'NC-PT2-07', { collection: 'Nico' }),
          externalItem(itemsPriTama02, 'NC-PT2-08', { collection: 'Nico' }),


          externalItem(itemsPriTama03, 'NC-PT3-01', { collection: 'Nico' }),
          externalItem(itemsPriTama03, 'NC-PT3-02', { collection: 'Nico' }),
          externalItem(itemsPriTama03, 'NC-PT3-03', { collection: 'Nico' }),
          externalItem(itemsPriTama03, 'NC-PT3-04', { collection: 'Nico' }),


          externalItem(itemsPriTama03, 'NC-PT3-05', { collection: 'Nico' }),
          externalItem(itemsPriTama03, 'NC-PT3-06', { collection: 'Nico' }),
          externalItem(itemsPriTama03, 'NC-PT3-07', { collection: 'Nico' }),
          externalItem(itemsPriTama03, 'NC-PT3-08', { collection: 'Nico' }),


          externalItem(itemsPriTama04, 'NC-PT4-01', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-02', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-03', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-04', { collection: 'Nico' }),


          externalItem(itemsPriTama04, 'NC-PT4-05', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-06', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-07', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-08', { collection: 'Nico' }),


          externalItem(itemsPriTama05, 'NC-PT5-01', { collection: 'Nico' }),
          externalItem(itemsPriTama05, 'NC-PT5-02', { collection: 'Nico' }),
          externalItem(itemsPriTama05, 'NC-PT5-03', { collection: 'Nico' }),
          externalItem(itemsPriTama05, 'NC-PT5-04', { collection: 'Nico' }),


          externalItem(itemsPriTama05, 'NC-PT5-05', { collection: 'Nico' }),
          externalItem(itemsPriTama05, 'NC-PT5-06', { collection: 'Nico' }),
          externalItem(itemsPriTama05, 'NC-PT5-07', { collection: 'Nico' }),
          externalItem(itemsPriTama05, 'NC-PT5-08', { collection: 'Nico' }),


          // [NOTE] ニコチケ SR
          // ================================================================================

          externalItem(itemsJewel05, 'NC-J5-07', { collection: 'Nico' }),
          externalItem(itemsJewel05, 'NC-J5-08', { collection: 'Nico' }),
          externalItem(itemsJewel05, 'NC-J5-09', { collection: 'Nico' }),
          item({ collection: 'Nico',  rare: 'SR' }),


          externalItem(itemsPriTama01, 'NC-PT1-12', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-13', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-14', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-15', { collection: 'Nico' }),


          externalItem(itemsPriTama04, 'NC-PT4-21', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-22', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-23', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-24', { collection: 'Nico' }),


          // [NOTE] ニコチケ R
          // ================================================================================

          externalItem(itemsJewel06, 'NC-J6-33', { collection: 'Nico' }),
          externalItem(itemsJewel06, 'NC-J6-34', { collection: 'Nico' }),
          externalItem(itemsJewel06, 'NC-J6-35', { collection: 'Nico' }),
          item({ collection: 'Nico',  rare: 'R' }),


          externalItem(itemsPriTama01, 'NC-PT1-48', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-49', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-50', { collection: 'Nico' }),
          externalItem(itemsPriTama01, 'NC-PT1-51', { collection: 'Nico' }),


          externalItem(itemsPriTama04, 'NC-PT4-46', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-47', { collection: 'Nico' }),
          externalItem(itemsPriTama04, 'NC-PT4-48', { collection: 'Nico' }),
          item({ collection: 'Nico',  rare: 'R' }),


        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },
      itemsIR () {
        return _.where(this.itemsMaJor, { rare: 'IR' })
      },

      itemsWR () {
        return _.where(this.itemsMaJor, { rare: 'WR' })
      },

      itemsER () {
        return _.where(this.itemsMaJor, { rare: 'ER' })
      },

      itemsFR () {
        return _.where(this.itemsMaJor, { rare: 'FR' })
      },

      itemsHR () {
        return _.where(this.itemsMaJor, { rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsJR () {
        return _.where(this.itemsMaJor, { rare: 'JR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'Nico' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },

      itemsNicoN () {
        return _.where(this.itemsNico, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'PBox' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'Molly' })
      },
    },

    methods: {
      collection (collection = '', rare = '') {
        return rare
          ? _.where(this.items, { collection, rare })
          : _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1,6,7,8,11,15]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="⭐️ WR ⭐️" color="#ffca59" :items="itemsWR" />
      <ItemList title="🥚 ER 🥚" color="#44cd1f" :items="itemsER" />
      <ItemList title="💎 JR 💎" color="#44cd1f" :items="itemsJR" />
      <ItemList title="✨ IR ✨" color="#edd50f" :items="itemsIR" />
      <ItemList title="サンキューキャンペーン|✨ IR ✨" color="#edd50f" :items="collection('999Campaign', 'IR')" />
    </template>

    <template #col2>
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col3>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="モーリー限定 SR ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col4>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>

    <template #col5>
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="サンキューキャンペーン|SR ★★" color="#00c7da" :items="collection('999Campaign', 'SR')" />
    </template>

    <template #col6>
      <ItemList title="✨ IR (再録) ✨" color="#edd50f" :items="collection('ReappearIR') | first(9 * 4)" />
    </template>

    <template #col7>
      <ItemList title="✨ IR (再録) ✨" color="#edd50f" :items="collection('ReappearIR') | rest(9 * 4)" :isOrphan="true" />
    </template>

    <template #col8>
      <ItemList title="キラッとアイドルCH|KR ★★★★" color="#ff5d91" :items="collection('KirattoIdol', 'KR')" />
      <ItemList title="キラチケいっぱい！|ハッピーキャンペーン！|クライマックス" color="#ff5d91" :items="collection('HappyCpnClimax', 'KR')" />
      <ItemList title="" color="#44cd1f" :items="collection('HappyCpnClimax', 'JR')" />
    </template>

    <template #col9>
      <ItemList title="キラッとアイドルCH|PR ★★★" color="#ffa1bc" :items="collection('KirattoIdol', 'PR')" />
      <ItemList title="キラッとアイドルCH|SR ★★" color="#00c7da" :items="collection('KirattoIdol', 'SR')" />
    </template>

    <template #col10>
      <ItemList title="キラッとアイドルCH|R ★" color="#feab0d" :items="collection('KirattoIdol', 'R')" />
      <ItemList title="キラッとアイドルCH|N" color="#f6c3b2" :items="collection('KirattoIdol', 'N')" />
    </template>

    <template #col11>
      <ItemList title="ジュエルアイドルCH|JR ◆◆◆◆" color="#edd50f" :items="collection('JewelIdol', 'JR')" />
    </template>

    <template #col12>
      <ItemList title="ジュエルアイドルCH|PR ★★★" color="#ffa1bc" :items="collection('JewelIdol', 'PR') | first(11 * 4)" />
    </template>

    <template #col13>
      <ItemList title="ジュエルアイドルCH|PR ★★★" color="#ffa1bc" :items="collection('JewelIdol', 'PR') | rest(11 * 4)" :isOrphan="true" />
      <ItemList title="ジュエルアイドルCH|SR ★★" color="#00c7da" :items="collection('JewelIdol', 'SR')" />
      <ItemList title="ジュエルアイドルCH|R ★" color="#feab0d" :items="collection('JewelIdol', 'R')" />
      <ItemList title="ジュエルアイドルCH|N" color="#f6c3b2" :items="collection('JewelIdol', 'N')" />
    </template>

    <template #col14>
      <ItemList title="プリ☆チャンファンタジー|ふっこくチャンネル2" color="#ff5d91" :items="collection('ReappearFR')" />
    </template>

    <template #col15>
      <ItemList title="復刻マスコット認定試験|✨ IR ✨" color="#edd50f" :items="collection('MascotExam')" />
      <ItemList title="ふっこく！|ラブパトリーナチャンネル" color="#a1c0fa" :items="collection('LovePato')" />
    </template>

    <template #col16>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR | first(7 * 4)" />
    </template>

    <template #col17>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR | rest(7 * 4)" :isOrphan="true" />
    </template>

    <template #col18>
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: $size-unit * 100;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }

  // コレクショングループ間の間隔 (IR)
  // .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(1) {
  //   .Item:nth-child(13),
  //   .Item:nth-child(14),
  //   .Item:nth-child(15),
  //   .Item:nth-child(16) {
  //     margin-top: $size-unit * 8;
  //   }
  // }

</style>
